import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { map, Observable } from 'rxjs';
import { getCompanyProfileData, getCustomerDashboard } from '../modal/dashboard';


@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(private http: HttpClient) { }

  getCustomerDashboard(payload:{}):Observable <getCustomerDashboard>{
    return this.http.post<getCustomerDashboard>(environment.apiUrl + "CircuitPortal/GetCustomerDashboard", payload).pipe(map(res => res as getCustomerDashboard))
  }

  getCompanyProfile(customerId:number):Observable <getCompanyProfileData>{
    return this.http.get<getCompanyProfileData>(environment.apiUrl + "CircuitPortal/GetCompanyProfile?customerId=" + customerId).pipe(map(res => res as getCompanyProfileData))
  }

}
